export default {
  feedback: {
    login_success: 'Zalogowano pomyślnie',
    logout_success: 'Wylogowano pomyślnie',
  },
};
